import styled from '@emotion/styled';
import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { SectionContentKeyword } from 'app-components/home/sections/components/SectionContentKeyword';

interface SectionContentKeywordsProps {
  className?: string;
  keywords: string[];
  maxKeywordShowCount?: number;
}

const MAX_KEYWORD_SHOW_COUNT = 2;

export const SectionContentKeywords = ({
  className,
  keywords,
  maxKeywordShowCount = MAX_KEYWORD_SHOW_COUNT,
}: SectionContentKeywordsProps) => {
  if (keywords.length <= 0) {
    return null;
  }

  return (
    <StyledKeywords className={className}>
      {keywords.slice(0, maxKeywordShowCount).map(it => (
        <SectionContentKeyword key={it} keyword={it} />
      ))}
      {keywords.length > maxKeywordShowCount && <p>{`외 ${keywords.length - maxKeywordShowCount}개`}</p>}
    </StyledKeywords>
  );
};

const StyledKeywords = styled.div`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  line-height: initial;
  gap: 4px;

  & > p {
    display: inline-block;
    color: ${Color.Gray500};
    ${Typography.XXXSmall};
    font-weight: ${FontWeight.Regular};
  }
`;
